import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import ConfettiExplosion from 'react-confetti-explosion'

interface FormlessConfettiProps {
  shouldShowConfetti?: boolean
}

const FormlessConfetti: React.FC<FormlessConfettiProps> = ({ shouldShowConfetti = false }) => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (shouldShowConfetti) {
      setActive(true)
      const timeoutId = setTimeout(() => setActive(false), 2000)
      return () => clearTimeout(timeoutId)
    }
    setActive(false)
  }, [shouldShowConfetti])

  if (!active) return null

  return (
    <Box
      sx={{
        position: 'relative',
        height: 0
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <ConfettiExplosion
          force={0.7}
          duration={2000}
          particleCount={120}
        />
      </Box>
    </Box>
  )
}

export default FormlessConfetti
